import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@mui/styles';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Container from '@mui/material/Container';
import collections from '../../../constants/FirestoreCollections';
import { useDispatch, useSelector } from 'react-redux';
import { useFirestore } from 'react-redux-firebase';
import { typeByName } from '../../../constants/Filters';
import { Box, Pagination, TextField, Typography } from '@mui/material';
import { toUpper, trim } from 'lodash';
import { actions } from '../../../actions';
import { targetTypesDescriptions } from '../../../constants/SystemMessages';
import { standardString } from '../../../utils/utils';
import Text from '../../../shared/Text';
import { professionalSM, specialtySM } from '../../../constants/Inputs';
import Message from '../components/Message';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
const MySwal = withReactContent(Swal);

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  systemMessages: {
    paddingTop: 0,
    paddingBottom: theme.spacing(4),
  },
  filtersContainer: {
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'flex-end',
  },
  addButtonContainer: {
    height: '100%',
  },
  form: {
    marginTop: theme.spacing(1),
  },
  formControl: {
    marginBlock: theme.spacing(1),
    minWidth: 120,
  },
  submitButtonContainer: {
    marginTop: theme.spacing(3),
  },
  selectRef: {
    fontSize: theme.sizes.sm.t1,
    color: '#bbb',
  },
}));

const targetTypes = {
  specialty: 'specialty',
  profesion: 'profesion',
};

export default function SystemMessages() {
  const classes = useStyles();

  // hooks
  const firestore = useFirestore();
  const appDispatch = useDispatch();
  const profile = useSelector((state) => state.firebase.profile);

  // redux states
  const organization = useSelector((state) => state.app.organization);
  const messages = useSelector((state) => state.app.messages);
  const professionals = useSelector((state) => state.app.professionals);
  const specialties = useSelector((state) => state.app.specialties);
  const configuration = useSelector((state) => state.app.labelsConfiguration);
  const config = useSelector((state) => state.app.prestobotsConfig);

  // local states
  const [showAddSpecialMessage, setShowAddSpecialMessage] = useState(false);
  const [systemMessagesKey, setSystemMessagesKey] = useState();
  const [page, setPage] = useState(1);
  const [systemMessagesKeyReply, setSystemMessagesKeyReply] = useState();
  const [originType, setOriginType] = useState(-1);
  const [targetType, setTargetType] = useState(-1);
  const [search, setSearch] = useState('');
  const [lastOrganization, setLastOrganization] = useState();

  const myRef = useRef(null);

  const isAdmin = profile && profile.claims && profile.claims.includes('admin');

  useEffect(() => {
    if (page !== 1) setPage(1);
  }, [search]);

  useEffect(() => {
    if (organization.id && organization.id !== lastOrganization) {
      setLastOrganization(organization.id);
      firestore
        .collection('configurations')
        .where('name', '==', 'API')
        .where('organizationId', '==', organization.id)
        .get()
        .then((res) => {
          let config;
          if (!res.empty) {
            config = { id: res.docs[0].id, ...res.docs[0].data() };
          }
          if (config) {
            appDispatch({
              type: actions.specialties,
              specialties: config.specialties,
            });
          }
        });
    }
  }, [appDispatch, firestore, lastOrganization, organization.id]);

  useEffect(() => {
    if (originType !== -1 && originType !== '' && targetType !== '' && targetType !== -1) {
      let originTypeKey = '';
      let targetTypeKey = '';

      switch (originType) {
        case typeByName.web:
          originTypeKey = 'WEB';
          break;
        case typeByName.whatsapp:
          originTypeKey = 'WA';
          break;
      }
      switch (targetType) {
        case targetTypes.profesion:
          targetTypeKey = 'PRO';
          break;
        case targetTypes.specialty:
          targetTypeKey = 'SPE';
          break;
      }

      setSystemMessagesKey(`systemMessages${originTypeKey}${targetTypeKey}`);
      setSystemMessagesKeyReply(
        `systemMessages${originTypeKey === 'WEB' ? 'WA' : 'WEB'}${targetTypeKey}`,
      );
    }
  }, [originType, targetType, targetTypes.profesion, targetTypes.specialty]);

  const newSystemMessage = (systemMessage, reply) => {
    appDispatch({
      type: actions.changeLoading,
      loading: { loading: true, priority: 1 },
    });
    const oldMessages = messages.filter((e) => e.type === systemMessagesKey);
    const oldMessagesReply = messages.filter((e) => e.type === systemMessagesKeyReply);
    const foundMessage = oldMessages.find(
      (e) => e.typeValue === systemMessage.typeValue && e.specialty === systemMessage.specialty,
    );
    const foundMessageReply = oldMessagesReply.find(
      (e) => e.typeValue === systemMessage.typeValue && e.specialty === systemMessage.specialty,
    );
    if (foundMessage || (reply && foundMessageReply)) {
      appDispatch({
        type: actions.alert,
        alert: {
          snackbarOpen: true,
          snackbarMessage: 'Ya existe otro mensaje con el mismo nombre!',
          snackbarSeverity: 'error',
        },
      });
      appDispatch({
        type: actions.changeLoading,
        loading: { loading: false, priority: 1 },
      });
      return;
    }
    firestore
      .collection(collections.messages)
      .add({
        ...systemMessage,
        reply,
        type: systemMessagesKey,
        organizationId: organization.id,
      })
      .then(() => {
        appDispatch({
          type: actions.alert,
          alert: {
            snackbarOpen: true,
            snackbarMessage: 'Mensaje creado',
            snackbarSeverity: 'success',
          },
        });
        if (reply) {
          firestore.collection(collections.messages).add({
            ...systemMessage,
            reply,
            type: systemMessagesKeyReply,
            organizationId: organization.id,
          });
        }
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log(err);
        appDispatch({
          type: actions.alert,
          alert: {
            snackbarOpen: true,
            snackbarMessage: 'Un problema ha ocurrido, intente nuevamente.',
            snackbarSeverity: 'error',
          },
        });
      })
      .finally(() => {
        appDispatch({
          type: actions.changeLoading,
          loading: { loading: false, priority: 1 },
        });
      });
  };

  const updateSystemMessage = (systemMessage, id, reply) => {
    appDispatch({
      type: actions.changeLoading,
      loading: { loading: true, priority: 1 },
    });
    firestore
      .collection(collections.messages)
      .doc(id)
      .update(systemMessage)
      .then(() => {
        if (reply) {
          const replyMessage = messages.find(
            (e) =>
              e.reply &&
              e.type === systemMessagesKeyReply &&
              e.typeValue === systemMessage.typeValue,
          );
          if (replyMessage) {
            if (reply) {
              firestore
                .collection(collections.messages)
                .doc(replyMessage.id)
                .update({ ...systemMessage, type: replyMessage.type })
                .then(() => {
                  appDispatch({
                    type: actions.alert,
                    alert: {
                      snackbarOpen: true,
                      snackbarMessage: 'Mensaje actualizado',
                      snackbarSeverity: 'success',
                    },
                  });
                });
            } else {
              firestore
                .collection(collections.messages)
                .doc(replyMessage.id)
                .update({ reply: false })
                .then(() => {
                  appDispatch({
                    type: actions.alert,
                    alert: {
                      snackbarOpen: true,
                      snackbarMessage: 'Mensaje actualizado',
                      snackbarSeverity: 'success',
                    },
                  });
                });
            }
          }
        } else {
          appDispatch({
            type: actions.alert,
            alert: {
              snackbarOpen: true,
              snackbarMessage: 'Se ha agregado el mensaje!',
              snackbarSeverity: 'success',
            },
          });
        }
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log(err);
        appDispatch({
          type: actions.alert,
          alert: {
            snackbarOpen: true,
            snackbarMessage: 'Un problema ha ocurrido, intente nuevamente.',
            snackbarSeverity: 'error',
          },
        });
      })
      .finally(() => {
        appDispatch({
          type: actions.changeLoading,
          loading: { loading: false, priority: 1 },
        });
      });
  };

  const newSystemMessageWrapper = (systemMessage, reply, isProfessional) => {
    const surname =
      systemMessage.typeValue.indexOf(',') !== -1
        ? systemMessage.typeValue.slice(0, systemMessage.typeValue.indexOf(','))
        : systemMessage.typeValue;

    if (isProfessional) {
      systemMessage.specialty = trim(systemMessage.specialty);
      if (!professionals.find((e) => e === surname)) {
        appDispatch({
          type: actions.professionals,
          professionals: [...professionals, surname],
        });
      }
    }
    newSystemMessage(systemMessage, reply);
  };

  const updateSystemMessageWrapper = (systemMessage, reply, id, isProfessional) => {
    const surname =
      systemMessage.typeValue.indexOf(',') !== -1
        ? systemMessage.typeValue.slice(0, systemMessage.typeValue.indexOf(','))
        : systemMessage.typeValue;
    if (isProfessional && !professionals.find((e) => e === surname)) {
      appDispatch({
        type: actions.professionals,
        professionals: [...professionals, surname],
      });
    }
    updateSystemMessage(systemMessage, id, reply);
  };

  const handleSubmit = ({ id, name, surname, ...systemMessage }, mode, index, type) => {
    const typeValue = standardString(
      type === 'professional'
        ? toUpper(`${trim(surname)}${name ? ', ' + trim(name) : ''}`)
        : systemMessage.typeValue,
    );
    if (type === 'professional') {
      if (!surname?.trim() || !name?.trim()) {
        appDispatch({
          type: actions.alert,
          alert: {
            snackbarOpen: true,
            snackbarMessage: 'El nombre y apellido son obligatorios.',
            snackbarSeverity: 'error',
          },
        });
        return;
      }
    } else if (type === 'specialty') {
      if (!systemMessage.typeValue?.trim()) {
        appDispatch({
          type: actions.alert,
          alert: {
            snackbarOpen: true,
            snackbarMessage: 'El campo de especialidad es obligatorio.',
            snackbarSeverity: 'error',
          },
        });
        return;
      }
    }

    switch (mode) {
      case 'create':
        newSystemMessageWrapper(
          { ...systemMessage, typeValue, creationDate: new Date() },
          !!systemMessage.reply,
          type === 'professional',
        );
        break;
      case 'update':
        updateSystemMessageWrapper(
          { ...systemMessage, typeValue, updateDate: new Date() },
          !!systemMessage.reply,
          id,
          type === 'professional',
        );
        break;
      default:
        throw new Error(`System messages mode of value ${mode} is unexpected`);
    }
  };

  const handleDelete = ({ id, name, surname, ...message }) => {
    MySwal.fire({
      text: '¿Está seguro/a que quiere borrarlo? Esta acción no se puede revertir.',
      showConfirmButton: true,
      showDenyButton: true,
      icon: 'error',
      input: message.reply && 'checkbox',
      inputPlaceholder: message.reply && 'Borrar replica',
      inputValue: true,
    }).then((result) => {
      if (result.isConfirmed) {
        const reply = result.isConfirmed;
        appDispatch({
          type: actions.changeLoading,
          loading: { loading: true, priority: 1 },
        });
        firestore
          .collection(collections.messages)
          .doc(id)
          .delete()
          .then(() => {
            if (message.reply) {
              const replyMessage = messages.find(
                (e) =>
                  e.reply && e.type === systemMessagesKeyReply && e.typeValue === message.typeValue,
              );
              if (reply) {
                firestore.collection(collections.messages).doc(replyMessage.id).delete();
              } else {
                firestore
                  .collection(collections.messages)
                  .doc(replyMessage.id)
                  .update({ reply: false, updatedAt: new Date() });
              }
            }
          })
          .finally(() => {
            appDispatch({
              type: actions.changeLoading,
              loading: { loading: false, priority: 1 },
            });
          });
      }
    });
  };
  const handleCancel = () => {
    setShowAddSpecialMessage(!showAddSpecialMessage);
  };

  const filteredMessages = messages
    ? messages
        .filter((message) => message.type === systemMessagesKey)
        .filter((message) => {
          return !search
            ? true
            : standardString(message.typeValue.replace(',', '')).indexOf(standardString(search)) !==
                -1 || standardString(message.specialty).indexOf(standardString(search)) !== -1;
        })
        .sort((a, b) => {
          if (a.updatedAt && !b.updatedAt) return -1;
          if (!a.updatedAt && b.updatedAt) return 1;
          if (!a.updatedAt || !b.updatedAt) return a.typeValue < b.typeValue ? -1 : 1;
          const dateA = new Date(a.updatedAt._seconds * 1000);
          const dateB = new Date(b.updatedAt._seconds * 1000);
          return dateA < dateB ? -1 : 1;
        })
    : [];

  const sharedValues = config && [
    ...config?.states
      ?.filter((state) => organization?.states?.includes(state.key))
      ?.map((state) => ({ value: parseInt(state.key), label: state.label })),
    { value: 3, label: 'terminado' },
  ];

  const professionalSMParams = {
    names: professionals?.map((e) => (e.includes(',') ? e.substr(0, e.indexOf(',')) : e)) || [],
    surnames:
      professionals?.filter((e) => e.includes(',')).map((e) => e.substr(e.indexOf(',') + 1)) || [],
    specialties: specialties?.map((e) => e.value) || [],
    values: sharedValues,
    isAdmin,
    originType: originType === 0 ? 'whatsapp' : 'webchat',
  };

  const specialtySMParams = {
    specialties: specialties?.map((e) => e.value) || [],
    values: sharedValues,
    isAdmin,
    originType: originType === 0 ? 'whatsapp' : 'webchat',
  };
  const inputsCreateProfessional = professionalSM({ onCreate: true, ...professionalSMParams });
  const inputsCreateSpecialty = specialtySM({ onCreate: true, ...specialtySMParams });
  const inputsUpdateProfessional = professionalSM({ onCreate: false, ...professionalSMParams });
  const inputsUpdateSpecialty = specialtySM({ onCreate: false, ...specialtySMParams });

  const pages =
    filteredMessages.length % 10 === 0
      ? parseInt(filteredMessages.length / 10)
      : parseInt(filteredMessages.length / 10) + 1;

  return (
    <div className="App">
      <Container className={classes.systemMessages} maxWidth="lg">
        {profile.isLoaded && (
          <Box ref={myRef}>
            <Grid container direction="row" className={classes.filtersContainer}>
              <Grid item xs={12}>
                {configuration && configuration.systemMessages && (
                  <Text configuration={configuration} propName="systemMessages" />
                )}
              </Grid>
              <Grid item xs={12} sm={3}>
                <Grid container>
                  <Grid item xs={12} sm={11}>
                    <FormControl fullWidth variant="outlined" className={classes.formControl}>
                      <Typography className={classes.selectRef}>Origen</Typography>
                      <Select
                        value={originType}
                        onChange={(event) => setOriginType(event.target.value)}
                      >
                        <MenuItem value={-1} disabled>
                          Selecciona una opción
                        </MenuItem>
                        <MenuItem value={typeByName.web}>WEB</MenuItem>
                        <MenuItem value={typeByName.whatsapp}>WHATSAPP</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Grid container>
                  <Grid item xs={12} sm={11}>
                    <FormControl fullWidth variant="outlined" className={classes.formControl}>
                      <Typography className={classes.selectRef}>Tipo</Typography>
                      <Select
                        value={targetType}
                        onChange={(event) => setTargetType(event.target.value)}
                      >
                        <MenuItem value={-1} disabled>
                          Selecciona una opción
                        </MenuItem>
                        <MenuItem value={targetTypes.profesion}>Profesional</MenuItem>
                        <MenuItem value={targetTypes.specialty}>Especialidad</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
              <Box display="flex" alignItems="flex-end" minWidth="300px">
                <Grid container>
                  <Grid item xs={12} sm={11}>
                    <FormControl fullWidth className={classes.formControl}>
                      <TextField
                        id="standard-basic"
                        label="Buscar"
                        variant="outlined"
                        disabled={(!originType && originType !== 0) || !targetType}
                        onChange={(event) => setSearch(event.target.value)}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Box>
              {systemMessagesKey && !showAddSpecialMessage && (
                <Box mb={2}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => setShowAddSpecialMessage(!showAddSpecialMessage)}
                  >
                    Agregar
                  </Button>
                </Box>
              )}
            </Grid>
            <Box>
              {pages > 1 && filteredMessages.length > 0 ? (
                <Box display="flex" justifyContent="center" mt={4}>
                  <Pagination
                    siblingCount={0}
                    count={pages}
                    color="primary"
                    page={page}
                    onChange={(e, value) => {
                      setPage(value);
                      myRef.current.scrollIntoView();
                    }}
                  />
                </Box>
              ) : null}
              {showAddSpecialMessage && (
                <Message
                  key={-1}
                  inputs={
                    targetTypesDescriptions[targetType] === targetTypesDescriptions.profesion
                      ? inputsCreateProfessional
                      : inputsCreateSpecialty
                  }
                  initialState={{
                    reply: true,
                    showFreeApps: false,
                    saveGestion: true,
                  }}
                  mode="create"
                  index="-1"
                  type={
                    targetTypesDescriptions[targetType] === targetTypesDescriptions.profesion
                      ? 'professional'
                      : 'specialty'
                  }
                  onDanger={handleCancel}
                  onSuccess={handleSubmit}
                />
              )}
              {filteredMessages
                .slice((page - 1) * 10, page * 10)
                .map(({ index, ...systemMessage }) => {
                  const surname =
                    systemMessage.typeValue.indexOf(',') !== -1
                      ? systemMessage.typeValue.substr(0, systemMessage.typeValue.indexOf(','))
                      : systemMessage.typeValue;
                  const name =
                    systemMessage.typeValue.indexOf(',') !== -1
                      ? systemMessage.typeValue.substr(systemMessage.typeValue.indexOf(',') + 2)
                      : '';
                  return (
                    <Message
                      key={systemMessage.id}
                      index={systemMessage.id}
                      inputs={
                        targetTypesDescriptions[targetType] === targetTypesDescriptions.profesion
                          ? inputsUpdateProfessional
                          : inputsUpdateSpecialty
                      }
                      initialState={{
                        ...systemMessage,
                        name,
                        surname,
                      }}
                      mode="update"
                      type={
                        targetTypesDescriptions[targetType] === targetTypesDescriptions.profesion
                          ? 'professional'
                          : 'specialty'
                      }
                      onSuccess={handleSubmit}
                      onDanger={handleDelete}
                    />
                  );
                })}
              {pages > 1 && filteredMessages.length > 0 ? (
                <Box display="flex" justifyContent="center" mt={4}>
                  <Pagination
                    siblingCount={0}
                    count={pages}
                    color="primary"
                    page={page}
                    onChange={(e, value) => {
                      setPage(value);
                      myRef.current.scrollIntoView();
                    }}
                  />
                </Box>
              ) : null}
            </Box>
          </Box>
        )}
      </Container>
    </div>
  );
}
